import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'informed';

class InputCheckbox extends React.Component {
  static propTypes = {
    col: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.bool,
    checked: PropTypes.bool,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    label: ''
  };

  render() {
    const { col, label, value, onChange, field, help, disabled, checked } =
      this.props;
    return (
      <div className={`${col} form-group`}>
        <label
          className="container-check-custom"
          style={{
            fontFamily: 'Public Sans',
            fontSize: '14px',
            fontWeight: 400,
            // lineHeight: '24px',
            letterSpacing: '0em',
            textAlign: 'left',
            color: '#4A4F58'
          }}
        >
          {label && <span className="ml-4"> {label} </span>}
          <Checkbox
            checked={checked}
            value={value}
            onChange={onChange}
            field={field}
            disabled={disabled}
          />
          <span className="checkmark" />
          {help && <small className="form-text text-muted">{help}</small>}
        </label>
      </div>
    );
  }
}

export default InputCheckbox;
